import { useMutation } from 'react-query';
import { AudioLibraryApi, AudioLibraryTypes } from '@frontend/api-audio-library';
import { useInvalidateQueries } from '@frontend/location-helpers';
import { queryKeys } from '../../query-keys';

export const useAudioLibraryMutations = () => {
  const invalidateQueries = useInvalidateQueries();

  const remove = useMutation({
    mutationFn: (payload: { mediaItemId: string; tenantId: string }) => {
      return AudioLibraryApi.deleteAudioLibrary(payload);
    },
    onSettled: () => {
      invalidateQueries(queryKeys.settings.audioLibrary());
    },
  });

  const update = useMutation({
    mutationFn: (payload: AudioLibraryTypes.RenameRequestType) => {
      return AudioLibraryApi.renameAudioLibrary(payload);
    },
    onSettled: () => {
      invalidateQueries(queryKeys.settings.audioLibrary());
    },
  });

  return {
    remove,
    update,
  };
};
